import { useTranslations } from "next-intl";

export const getDropDownItems = (
  t: ReturnType<typeof useTranslations>
): { name: string; key: string }[] => [
  { name: t("Other.mostRelevant"), key: "recommended" },
  { name: t("Other.priceLowToHigh"), key: "price_asc" },
  { name: t("Other.startRatingLowToHigh"), key: "starts_asc" },
  { name: t("Other.priceHighToLow"), key: "price_desc" },
  { name: t("Other.startRatingHightToLow"), key: "starts_desc" },
];

export const getFlightDropDownItems = (
  t: ReturnType<typeof useTranslations>
): { name: string; key: string }[] => [
  { name: t("Other.mostRelevant"), key: "recommended" },
  { name: t("Other.priceLowToHigh"), key: "price_asc" },
  { name: t("Other.priceHighToLow"), key: "price_desc" },
  { name: t("Other.fastest"), key: "duration_asc" },
  { name: t("Other.leastStops"), key: "stops_asc" },
];

export const WEB3_DISCOUNT_ID = "web3discount";

/** A discount every visitor gets when their stay meets the rule's conditions. */
export const STAY_DISCOUNT_TYPE = "stay";
